// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const listAlertsApi = () => api().get('/alerts');

export default listAlertsApi;
